import { Util } from 'src/app/utils/util';
import { FormUtil } from '../../../utils/form';
import { EstabSevicoModel } from '../caracterizacao/estab-sevico.model';
import { FiltroBuscaGridModel } from '../classes-filtro-busca-grid';
import { EstabComplementarModel, IEstabComplementar } from './estab-complementar.model';
import { EstabEnderecoComplementarModel } from './estab-endereco-complementar.model';
import { IIdentificacaoPrincipal, IRascunhoIdentificacao, RascunhoIdentificacaoModel } from './estab-principal.model';

export class IdentificacaoModulo {
    principal: RascunhoIdentificacaoModel;
    identificacaoPrincipal: IIdentificacaoPrincipal;
    complementar: EstabComplementarModel;
    enderecosComplementares: EstabEnderecoComplementarModel;

    constructor() {
        this.principal = null;
        this.identificacaoPrincipal = null;
        this.complementar = null;
        this.enderecosComplementares = null;
    }

    rascunhoParaIdentificacao(rascunho: any, resultadoEndereco: any) {
        this.tratarRascunhoPrincipal(rascunho, resultadoEndereco);
        this.tratarRascunhoComplementar(rascunho);
        this.tratarRascunhoEnderecoComplementar(rascunho);
    }

    async salvarEnderecoComplementar(enderecoComplementar: EstabEnderecoComplementarModel, form: any) {
        enderecoComplementar.identificacao = form.identificacao;
        enderecoComplementar.cep = form.cep;
        enderecoComplementar.logradouro = form.logradouro;
        enderecoComplementar.numeroEndereco = form.numeroEndereco;
        enderecoComplementar.complemento = form.complemento;
        enderecoComplementar.bairro = form.bairro;
        enderecoComplementar.siglaUf = form.siglaUf;
        enderecoComplementar.codigoUf = form.codigoUf;
        enderecoComplementar.telefone = form.telefone;
        enderecoComplementar.nomeMunicipio = form.municipio;
        enderecoComplementar.codigoMunicipioIBGE = form.codigoIbgeMunicipio;
        enderecoComplementar.dataAtivacao = form.dataAtivacao;
        enderecoComplementar.dataDesativacao = form.dataDesativacao;
    }

    async excluirEnderecoComplementar(enderecoComplementar: EstabEnderecoComplementarModel) { }

    async syncFormPrincipal(form: any) {
        const cnpjCpf = form.cnpjCpf ? Util.removeMascaraCpfCnpj(form.cnpjCpf) : '';
        this.identificacaoPrincipal = this.identificacaoPrincipal ? this.identificacaoPrincipal : new IIdentificacaoPrincipal();
        this.principal.cnpj = cnpjCpf.length === 14 ? cnpjCpf : '';
        this.principal.cpf = cnpjCpf.length === 11 ? cnpjCpf : '';
        this.principal.nomeFantasia = form.nomeFantasia ? form.nomeFantasia : '';
        this.identificacaoPrincipal.nomeFantasia = form.nomeFantasia ? form.nomeFantasia : '';
        this.identificacaoPrincipal.telefone = form.telefone ? form.telefone : '';
        this.identificacaoPrincipal.email = form.email ? form.email : '';
        this.identificacaoPrincipal.nomeEmpresarial = form.nomeEmpresarialMantenedora ? form.nomeEmpresarialMantenedora : '';
        this.identificacaoPrincipal.codigoNaturezaJuridica = form.naturezaJuridicaMantenedora ? form.naturezaJuridicaMantenedora : '';
        this.identificacaoPrincipal.cnpj = form.cnpjMantenedora ? form.cnpjMantenedora : '';
        this.identificacaoPrincipal.cep = form.cep ? form.cep : '';
        this.identificacaoPrincipal.logradouro = form.logradouro ? form.logradouro : '';
        this.identificacaoPrincipal.numeroEndereco = form.numeroEndereco ? form.numeroEndereco : '';
        this.identificacaoPrincipal.complementoEndereco = form.complemento ? form.complemento : '';
        this.identificacaoPrincipal.bairro = form.bairro ? form.bairro : '';
        this.identificacaoPrincipal.codigoUf = form.codigoUf ? form.codigoUf : '';
        this.identificacaoPrincipal.codigoMunicipioIBGE = form.codigoIbgeMunicipio ? form.codigoIbgeMunicipio : '';
        this.identificacaoPrincipal.municipio = form.municipio ? form.municipio.split('-')[1].trim() : '';
        this.identificacaoPrincipal.tipoEstrutura = form.tipoEstruturaId ? form.tipoEstruturaId : '';
        this.identificacaoPrincipal.latitude = form.latitude ? form.latitude : '';
        this.identificacaoPrincipal.longitude = form.longitude ? form.longitude : '';
        this.identificacaoPrincipal.cpf = cnpjCpf.length === 11 ? cnpjCpf : '';
    }

    async syncFormComplemento(form: any) {
        this.complementar.cnpjAdministradorTerceiro = form.cnpjAdministradorTerceiro ? form.cnpjAdministradorTerceiro : '';
        this.complementar.nomeEmpresarialAdministradorTerceiro =
            form.nomeEmpresarialAdministradorTerceiro ? form.nomeEmpresarialAdministradorTerceiro : '';
        this.complementar.naturezaJuridicaAdministradorTerceiro =
            form.naturezaJuridicaAdministradorTerceiro ? form.naturezaJuridicaAdministradorTerceiro : '';
        this.complementar.distritoSanitario = form.distritoSanitario ? form.distritoSanitario : '';
        this.complementar.regionalSaude = form.regionalSaude ? form.regionalSaude : '';
        this.complementar.idDistritoSanitario = form.idDistritoSanitario ? form.idDistritoSanitario : '';
        this.complementar.idRegionalSaude = form.idRegionalSaude ? form.idRegionalSaude : '';
        this.complementar.idDsei = form.idDsei ? form.idDsei : '';
        this.complementar.dsei = form.dsei ? form.dsei : '';
        this.complementar.idPoloBase = form.idPoloBase ? form.idPoloBase : '';
        this.complementar.poloBase = form.poloBase ? form.poloBase : '';
        this.complementar.idAldeia = form.idAldeia ? form.idAldeia : '';
        this.complementar.aldeia = form.aldeia ? form.aldeia : '';
    }

    async syncEnderecoComplementarForm(form: any, servicosVinculados: any) {
        this.enderecosComplementares.identificacao = form.identificacao ? form.identificacao : '';
        this.enderecosComplementares.cep = form.cep = form.cep ? form.cep : '';
        this.enderecosComplementares.logradouro = form.logradouro = form.logradouro ? form.logradouro : '';
        this.enderecosComplementares.numeroEndereco = form.numeroEndereco = form.numeroEndereco ? form.numeroEndereco : '';
        this.enderecosComplementares.complemento = form.complemento = form.complemento ? form.complemento : '';
        this.enderecosComplementares.bairro = form.bairro = form.bairro ? form.bairro : '';
        this.enderecosComplementares.siglaUf = form.siglaUf = form.siglaUf ? form.siglaUf : '';
        this.enderecosComplementares.codigoUf = form.codigoUf = form.codigoUf ? form.codigoUf : '';
        this.enderecosComplementares.telefone = form.telefone = form.telefone ? form.telefone : '';
        this.enderecosComplementares.nomeMunicipio = form.municipio = form.municipio ? form.municipio.split('-')[1].trim() : '';
        // tslint:disable-next-line:max-line-length
        this.enderecosComplementares.codigoMunicipioIBGE = form.codigoIbgeMunicipio = form.codigoIbgeMunicipio ? form.codigoIbgeMunicipio : '';
        this.enderecosComplementares.dataAtivacao = form.dataAtivacao = form.dataAtivacao ? form.dataAtivacao : '';
        this.enderecosComplementares.dataDesativacao = form.dataDesativacao = form.dataDesativacao ? form.dataDesativacao : '';
        this.enderecosComplementares.servicosVinculados = servicosVinculados = servicosVinculados ? servicosVinculados : [];
    }

    async buscarEnderecoComplementar(filtros: FiltroBuscaGridModel): Promise<any> {
    }

    private tratarRascunhoPrincipal(rascunho: any, resultadoEndereco: any) {

        const principal: IRascunhoIdentificacao = {
            id: rascunho ? rascunho.id : '',
            cnes: rascunho ? rascunho.cnes : '',
            cnpj: rascunho ? FormUtil.formatarCpfCnpj(rascunho.cnpj) : '',
            cpf: rascunho ? FormUtil.formatarCpfCnpj(rascunho.cpf) : '',
            nomeFantasia: rascunho ? rascunho.nomeFantasia : '',
            usuarioCriacao: '',
            statuscodigo: rascunho.statusRascunho ? rascunho.statusRascunho.codigo : '',
            statusdescricao: rascunho.statusRascunho ? rascunho.statusRascunho.descricao : '',
            usuarioAlteracao: ''
        };
        this.principal = principal;
        let strtipoEstrutura = '';
        let strtipoEstruturaid = '';
        if (resultadoEndereco) {
            if (resultadoEndereco.tipoEstrutura) {
                // tslint:disable-next-line:max-line-length
                strtipoEstrutura = resultadoEndereco.tipoEstrutura.descricao ? resultadoEndereco.tipoEstrutura.descricao : resultadoEndereco.tipoEstrutura;
                // tslint:disable-next-line:max-line-length
                strtipoEstruturaid = resultadoEndereco.tipoEstruturaid ? resultadoEndereco.tipoEstruturaid : resultadoEndereco.tipoEstrutura.codigo;
            }
        }

        this.identificacaoPrincipal = {
            // tslint:disable-next-line:max-line-length
            cnpj: resultadoEndereco ? FormUtil.formatarCpfCnpj(resultadoEndereco.cnpj) : '',
            nomeFantasia: resultadoEndereco ? resultadoEndereco.nomeFantasia : '',
            codigoNaturezaJuridica: resultadoEndereco ? `${resultadoEndereco.codigoNaturezaJuridica}` : '',
            telefone: resultadoEndereco ? Util.somenteNumeros(resultadoEndereco.telefone) : '',
            email: resultadoEndereco ? resultadoEndereco.email : '',
            nomeEmpresarial: resultadoEndereco ? resultadoEndereco.nomeEmpresarial : '',
            cep: resultadoEndereco ? FormUtil.formatarCEP(resultadoEndereco.cep) : '',
            logradouro: resultadoEndereco ? resultadoEndereco.logradouro : '',
            numeroEndereco: resultadoEndereco ? resultadoEndereco.numeroEndereco : '',
            complementoEndereco: resultadoEndereco ? resultadoEndereco.complementoEndereco : '',
            bairro: resultadoEndereco ? resultadoEndereco.bairro : '',
            municipio: resultadoEndereco ? resultadoEndereco.municipio : '',
            codigoMunicipioIBGE: resultadoEndereco ? resultadoEndereco.codigoMunicipioIBGE : '',
            tipoEstrutura: strtipoEstrutura,
            // tslint:disable-next-line:max-line-length
            // tipoEstrutura: resultadoEndereco && resultadoEndereco.tipoEstrutura.descricao ? resultadoEndereco.tipoEstrutura.descricao : (resultadoEndereco ? resultadoEndereco.tipoEstrutura : ''),
            tipoEstruturaid: strtipoEstruturaid,
            // tslint:disable-next-line:max-line-length
            // tipoEstruturaid: resultadoEndereco && resultadoEndereco.tipoEstrutura.codigo ? resultadoEndereco.tipoEstrutura.codigo : (resultadoEndereco ? resultadoEndereco.tipoEstruturaid : ''),
            latitude: resultadoEndereco ? resultadoEndereco.latitude : '',
            longitude: resultadoEndereco ? resultadoEndereco.longitude : '',
            codigoUf: resultadoEndereco ? resultadoEndereco.codigoUf : '',
            cpf: resultadoEndereco ? FormUtil.formatarCpfCnpj(resultadoEndereco.cpf) : '',
            codigoUnidade: '',
        };
    }

    private tratarRascunhoComplementar(rascunho: any) {
        const complementar: IEstabComplementar = {
            // tslint:disable-next-line:max-line-length
            cnpjAdministradorTerceiro: null, // TODO Um estabelecimento pode ter mais de uma Entidade Administradora? (Identificação Complementar)
            nomeEmpresarialAdministradorTerceiro: null,
            naturezaJuridicaAdministradorTerceiro: null,
            distritoSanitario: rascunho.record ? rascunho.record.codigoDistritoSanitario : '',
            regionalSaude: rascunho.record ? rascunho.record.codigoRegiaoSaude : '',
            idRegionalSaude: null,
            idDistritoSanitario: null,
            idDsei: null,
            dsei: null,
            idPoloBase: null,
            poloBase: null,
            idAldeia: null,
            aldeia: null,
        };
        if (rascunho.dadosIndigenas) {
            complementar.dsei = rascunho.dadosIndigenas.nomeDsei;
            complementar.poloBase = rascunho.dadosIndigenas.poloBase;
            complementar.aldeia = rascunho.dadosIndigenas.nomeAldeia;
        }
        this.complementar = complementar;
    }

    private tratarRascunhoEnderecoComplementar(rascunho: any) {
        const endereco: EstabEnderecoComplementarModel = {
            id: null,
            identificacao: null,
            cep: null,
            logradouro: null,
            numeroEndereco: null,
            complemento: null,
            bairro: null,
            siglaUf: null,
            codigoUf: null,
            telefone: null,
            nomeMunicipio: null,
            codigoMunicipioIBGE: null,
            dataAtivacao: null,
            dataDesativacao: null,
            servicosVinculados: null,
        };
        this.enderecosComplementares = endereco;
    }

    private rascunhoParaServicosEquipe(servicos = []): EstabSevicoModel[] {
        const lista: EstabSevicoModel[] = [];

        return lista;
    }


}
